module.exports = __webpack_public_path__ + "img/link_white_icon.c26f3f01.svg";